"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionTree = void 0;
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const Dots_1 = __importDefault(require("@opsbase/web-ui/Dots"));
const react_1 = __importStar(require("react"));
const useFedActions_1 = __importDefault(require("../FedController/useFedActions"));
const useFedDB_1 = __importDefault(require("../FedController/useFedDB"));
const useFedDnd_1 = __importDefault(require("../FedController/useFedDnd"));
const QuestionTreeList_1 = __importDefault(require("./QuestionTreeList"));
const makeMyClasses = dragging => ({
    root: {
        scrollBehavior: dragging ? 'auto' : 'smooth',
        paddingBottom: 20,
    },
});
exports.QuestionTree = react_1.default.memo(() => {
    const db = (0, useFedDB_1.default)();
    const { dragging } = (0, useFedDnd_1.default)();
    const { doKeyDown } = (0, useFedActions_1.default)();
    const [initialised, setInitialised] = (0, react_1.useState)(false);
    const myCss = (0, web_css_1.default)(makeMyClasses, [!!dragging]);
    const rootList = db.lists['root'];
    (0, react_1.useEffect)(() => {
        var _a;
        if (!initialised && ((_a = rootList.childQIds) === null || _a === void 0 ? void 0 : _a.length)) {
            requestAnimationFrame(() => setInitialised(true));
        }
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [rootList]);
    const handleClick = (0, react_1.useCallback)(e => {
        var _a, _b;
        (_b = (_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.focus) === null || _b === void 0 ? void 0 : _b.call(_a);
    }, []);
    const handleKeyDown = (0, react_1.useCallback)((e) => {
        doKeyDown(e);
    }, [doKeyDown]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Dots_1.default, { hidden: initialised, style: { margin: '40px auto' }, color: lib_palette_1.default.primary }),
        react_1.default.createElement(Vertical_1.default, { onClick: handleClick, onKeyDown: handleKeyDown, scroll: true, classes: { root: myCss.root } },
            react_1.default.createElement(QuestionTreeList_1.default, { listId: 'root' }))));
});
exports.default = exports.QuestionTree;
